import type { z } from 'zod';

import {
  createFindManyAiToolInputSchema,
  namedItemFilterFieldMappings,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import {
  PROMPT_AI_TOOL_FILTER_FIELDS,
  PROMPT_AI_TOOL_SEARCH_SCALAR_FIELDS,
  PROMPT_AI_TOOL_SORTABLE_FIELDS,
} from '../shared/botAiToolQueryInput';

const promptFilterFieldMappingsLocal = {
  ...namedItemFilterFieldMappings,
  id: { path: ['id'], valueType: 'string' },
  description: { path: ['description'], valueType: 'string' },
  group: { path: ['group'], valueType: 'string' },
  handle: { path: ['handle'], valueType: 'string' },
  text: { path: ['text'], valueType: 'string' },
} as const;

export const promptFilterFieldMappings = promptFilterFieldMappingsLocal;

export const findPromptsInputSchema = createFindManyAiToolInputSchema({
  filterableFields: PROMPT_AI_TOOL_FILTER_FIELDS,
  filterFieldMappings: promptFilterFieldMappingsLocal,
  sortableFields: PROMPT_AI_TOOL_SORTABLE_FIELDS,
  selectableScalars: PROMPT_AI_TOOL_SEARCH_SCALAR_FIELDS,
});

export type FindPromptsInput = z.infer<typeof findPromptsInputSchema>;
